// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"styles_errorMessage__IfmCq","message":"styles_message__1TKd_"};